import { StatusType } from '../types/commonTypes';
import {
  SAVE_PASSWORD_FULFILLED,
  SAVE_PASSWORD_PENDING,
  SAVE_PASSWORD_REJECTED
} from '../actions/savePassword';
import { CANCEL_CHANGES } from '../actions/cancelChanges';

export default function passwordStatusReducer(
  state: StatusType = { status: 'INITIAL' },
  action: any
): StatusType {
  switch (action.type) {
    case SAVE_PASSWORD_FULFILLED: {
      return {
        status: 'SUCCESS'
      };
    }
    case SAVE_PASSWORD_PENDING: {
      return {
        status: 'PROCESSING'
      };
    }
    case SAVE_PASSWORD_REJECTED: {
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.data
      ) {
        const { data } = action.payload.response;
        return {
          status: 'FAILED',
          messages: data.messages || [
            {
              type: 'error',
              cmsContentId: 'system-error-message'
            }
          ]
        };
      }
      return {
        status: 'FAILED',
        messages: [
          {
            type: 'error',
            cmsContentId: 'system-error-message'
          }
        ]
      };
    }
    case CANCEL_CHANGES: {
      if (action.payload.widget === 'password') {
        return { ...state, status: 'INITIAL' };
      }
      return state;
    }
    default:
      return state;
  }
}
